const initialState = {
    totalScore:0,
    loading:false,
    start:false,
    level:0,
    questions:null,
    increasePoints:0
}



export default function quizReducer(state=initialState,action){
    switch(action.type){
        case "SET_LOADING":
            return{
                ...state,
                loading:action.payload
            }
        case "START_QUIZ":
            return {
                ...state,
                start:true,
                level:action.payload.level.level,
                questions:action.payload.questions,
                increasePoints:action.payload.increasePoints
            }
        case "INCREASE_SCORE":
            return {
                ...state,
                totalScore:state.totalScore + state.increasePoints
            }
        case "RESET_QUIZ":
            return initialState
         default :
            return state;
    }
}